import {useState, useEffect, ReactNode} from 'react'
import VantaTopology from './VantaBackground'

interface ResponsiveWrapperProps {
  children: ReactNode
}

const ResponsiveWrapper: React.FC<ResponsiveWrapperProps> = ({children}) => {
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return isMobile ? (
    <div className='mobile-wrapper'>{children}</div>
  ) : (
    <VantaTopology>{children}</VantaTopology>
  )
}

export {ResponsiveWrapper}
